import {
  ReceiptTabKey,
  ReturnReceiptItem,
  ReturnReceiptItemRes,
  ReturnReceiptSummary,
  ReturnReceiptSummaryRes,
  SCAN_STATUS_TO_TAB,
} from './types'
import type { ReturnShipperDisplay } from '@/pages/return/coMingle'

export const toSummary = (res: ReturnReceiptSummaryRes): ReturnReceiptSummary => ({
  closeDate: res.clsDate ?? '',
  inCenter: res.whNm ?? '',
  assignDate: res.assignDate ?? '',
  totalQty: res.totalCount,
  normalQty: res.successCount,
  missQty: res.missCount,
  unregQty: res.failCount,
  dupQty: res.dupCount,
})

export const toItem = (res: ReturnReceiptItemRes & ReturnShipperDisplay, coMingleEnabled = false): ReturnReceiptItem => ({
  shipper: (coMingleEnabled ? res.shipperName : null) ?? res.sprNm ?? '',
  assignDate: res.assignDate ?? '',
  closeDate: res.clsDate ?? '',
  arriveDate: res.scanDate ?? '',
  returnInvoiceNo: res.rtnInvoiceNo ?? '',
  inCenter: res.whNm ?? '',
  result: res.scanStatus ?? '',
  resultTab: SCAN_STATUS_TO_TAB[res.scanStatus ?? ''] ?? ('all' as ReceiptTabKey),
  outCenter: res.giWhNm ?? '',
  orgInvoiceNo: res.orgInvoiceNo ?? '',
  orderNo: res.ordNo ?? '',
  worker: res.insBy ?? '',
})
